<template>
    <transition name="fade">
        <div
            v-if="error !== null && error !== undefined"
            class="alert alert-danger dismissable"
            role="alert"
        >
            <strong>Error!</strong> <span v-html="$t(error)"></span>
            <button type="button" class="close" aria-label="Close" @click="clearError">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </transition>
</template>

<script>
    export default {
        computed: {
            error() {
                return this.$store.state.error
            }
        },

        watch: {
            error: function(val) {
                if (val !== null) {
                    const self = this;
                    window.setTimeout(function () { self.$store.commit('clearError') }, 3000)
                }
            }
        },

        methods: {
            clearError() {
                this.$store.dispatch('clearErrors')
            }
        }
    }
</script>

<style scoped>
    .alert.alert-danger.absolute {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 21;
    }

    .alert.alert-danger.absolute > button {
        margin-left: 16px;
    }
</style>
